// extracted by mini-css-extract-plugin
export default {"banner":"index_banner__A-D6Z","item":"index_item__XR5u+","customIndicator":"index_customIndicator__PJbnD","banner_dot":"index_banner_dot__EHsPo","banner3":"index_banner3__JetaX"};